import { Outlet, createFileRoute } from "@tanstack/react-router";
import { TbCalendarTime } from "react-icons/tb";

import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.MANAGEMENT_SCHEDULES)({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "schedule_overview",
                to: APP_ROUTES_TO.MANAGEMENT_SCHEDULES,
            },
            sidebar: {
                label: "user_schedules",
                icon: TbCalendarTime,
            },
            title: "schedule_overview",
        },
    },
});

function RouteComponent() {
    return <Outlet />;
}
